import React, { Component } from "react";
import validator from "validator";
import { escape } from "he";
import Recaptcha from "react-recaptcha";
import { emailSecret } from "../../../lib/config.js";

import { postToWebform } from "../../fetchJSON.js";

const registrationCutoff = new Date("2023-05-20");
const registrationsOpen = registrationCutoff.getTime() > Date.now();
const registrationCost = 130;
const year = 2023;
const days = "Friday 19th May – Sunday 21st May";
const location = "Blue Lagoon Centre, Dodges Ferry";
const webformUUID = "54f3bf3a-00e0-4aa9-9f1f-0d7cb07f324b";

class MorphCamp extends Component {
	constructor() {
		super();
		this.state = {
			name: "",
			email: "",
			phone: "",
			allergies: "",
			comments: "",
			formErrorMessage: "",
			formValid: false,
			formSubmitted: false,
			submissionID: null,
			validRecaptcha: false
		};

		this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
		this.verifyCallback = this.verifyCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.resetRegistrationForm = this.resetRegistrationForm.bind(this);
	}

	resetRegistrationForm() {
		this.setState({
			name: "",
			email: "",
			phone: "",
			allergies: "",
			comments: "",
			formErrorMessage: "",
			formValid: false,
			formSubmitted: false,
			submissionID: null,
			validRecaptcha: false
		});
	}

	handleChange(e) {
		var change = {};
		change[e.target.name] = e.target.value;
		this.setState(change);
	}

	recaptchaLoaded() {
		console.log("recaptcha loaded");
	}
	verifyCallback(response) {
		if (response) {
			this.setState({ validRecaptcha: true });
		}
	}

	handleSubmit(e) {
		e.preventDefault();
		var errorMessage = "";
		if (this.state.validRecaptcha !== true) {
			errorMessage += "Please verify that you are not a robot.\n";
		}

		if (validator.isEmpty(this.state.name)) {
			errorMessage += "Please enter a name.\n";
		}
		if (validator.isEmpty(this.state.email) || !validator.isEmail(this.state.email)) {
			errorMessage += "Please enter a valid email address.\n";
		}
		if (validator.isEmpty(this.state.phone)) {
			errorMessage += "Please enter a phone number.\n";
		}
		if (validator.isEmpty(this.state.allergies)) {
			errorMessage += "Please enter whether there are any allergies we should know about.\n";
		}

		if (errorMessage !== "") {
			this.setState({ formErrorMessage: errorMessage });
			return false;
		} else {
			this.setState({ formValid: true });

			//handle posting to drupal and show success message
			var form = new FormData();
			form.append("webform", webformUUID);
			form.append("submission[data][1][values][0]", escape(this.state.name));
			form.append("submission[data][2][values][0]", escape(this.state.email));
			form.append("submission[data][3][values][0]", escape(this.state.phone));
			form.append("submission[data][4][values][0]", escape(this.state.allergies));
			form.append("submission[data][5][values][0]", escape(this.state.comments));
			var that = this;
			postToWebform(form, function (data) {
				that.setState({ submissionID: data.sid });
				that.setState({ formSubmitted: true });

				const values = {
					name: that.state.name,
					email: that.state.email,
					event: `Morph Camp ${year}`,
					allergies: that.state.allergies,
					comments: that.state.comments
				};
				//send email via nextjs site
				const inputs = {
					targetEmail: that.state.email,
					sid: data.sid,
					registrationCost: registrationCost,
					message: values,
					secret: emailSecret
				};

				fetch("https://mailer.crckingston.org.au/api/send", {
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					mode: "no-cors",
					body: JSON.stringify(inputs)
				})
					.then((response) => response.json())
					.then((data) => {
						console.log("Success:", data);
					})
					.catch((error) => {
						console.error("Error:", error);
					});
			});
		}
	}

	render() {
		var registrationForm;
		if (!this.state.formValid && registrationsOpen) {
			registrationForm = (
				<section>
					<p>
						{/*<strong>Theme:</strong> Belief in the Real World <br /> */}
						<strong>Cost:</strong> ${registrationCost}
					</p>
					<p>
						{days} {year}
						<br />
						{location}
					</p>

					<p>
						Any questions? Email{" "}
						<a href="mailto:morph@kingstoncrc.org.au" target="_blank" rel="noopener noreferrer">
							morph@kingstoncrc.org.au
						</a>
					</p>

					<form onSubmit={this.handleSubmit}>
						<label style={{ fontWeight: "bold" }}>
							Full Name{" "}
							<sup>
								<i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red" }} />
							</sup>
						</label>
						<br />
						<input
							type="text"
							name="name"
							size="60"
							maxLength="128"
							onChange={this.handleChange.bind(this)}
							value={this.state.name}
						/>
						<br />
						<br />
						<label style={{ fontWeight: "bold" }}>
							Email{" "}
							<sup>
								<i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red" }} />
							</sup>
							<br />
						</label>
						<br />
						<input
							type="text"
							name="email"
							size="60"
							maxLength="128"
							onChange={this.handleChange.bind(this)}
							value={this.state.email}
						/>
						<br />
						<br />
						<label style={{ fontWeight: "bold" }}>
							Phone Number{" "}
							<sup>
								<i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red" }} />
							</sup>
						</label>
						<br />
						<input
							type="text"
							name="phone"
							size="60"
							maxLength="128"
							onChange={this.handleChange.bind(this)}
							value={this.state.phone}
						/>
						<br />
						<br />
						<label style={{ fontWeight: "bold" }}>
							Allergy Information{" "}
							<sup>
								<i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red" }} />
							</sup>
						</label>
						<br />
						<textarea
							name="allergies"
							cols="90"
							rows="5"
							onChange={this.handleChange.bind(this)}
							value={this.state.allergies}
						/>
						<br />
						<span style={{ fontSize: "13px" }}>Please write 'None' if you do not have any allergies.</span>
						<br />
						<br />
						<label style={{ fontWeight: "bold" }}>Additional Comments</label>
						<br />
						<textarea
							name="comments"
							cols="90"
							rows="5"
							onChange={this.handleChange.bind(this)}
							value={this.state.comments}
						/>
						<br />
						<span style={{ fontSize: "13px" }}>
							Any additional notes that you would like to pass onto the organisers.
						</span>
						<br />
						<br />
						<Recaptcha
							sitekey="6LedbmUaAAAAAGkk_wLogRd5CIl38cIb_zeE6p04"
							render="explicit"
							onloadCallback={this.recaptchaLoaded}
							verifyCallback={this.verifyCallback}
						/>
						,
						<br />
						<input type="submit" value="Register" className="btn btn-primary" />
						<br />
						<br />
						<div id="errorMessage" style={{ whiteSpace: "pre-line", fontWeight: "bold" }}>
							{this.state.formErrorMessage}
						</div>
					</form>
				</section>
			);
		} else if (!this.state.formValid && !registrationsOpen) {
			registrationForm = (
				<section>
					<p>
						{days} {year}
						<br />
						{location}
					</p>

					<br />
					<br />
					<p className="lead">Registrations for Morph Camp {year} have now closed.</p>

					<p>
						If you have any questions please email{" "}
						<a href="mailto:morph@kingstoncrc.org.au" target="_blank" rel="noopener noreferrer">
							morph@kingstoncrc.org.au
						</a>
					</p>
				</section>
			);
		} else {
			registrationForm = <div></div>;
		}

		var formSubmitted;
		if (this.state.formSubmitted) {
			formSubmitted = (
				<div>
					Thank you for registering for Morph Camp!
					<br />
					<br />
					<strong>
						Please note that your registration for Morph Camp is not complete until payment has been received.
					</strong>
					<br />
					<br />
					To complete your registration, please pay the full amount of ${registrationCost}.00 into the churches bank
					account:
					<br />
					<br />
					Direct Deposit:
					<br />
					Account Name: CRCST INC
					<br />
					BSB: 067 026
					<br />
					Account No: 2802 2340
					<br />
					Reference: MorphC {this.state.submissionID} (This is used to identify your payment in our system)
					<br />
					<br />
					<strong>
						Please also make sure that the medical form linked below is completed and either bring it to camp or a Morph
						night prior to the camp.
					</strong>
					<br />
					<a href="https://api.crckingston.org.au/sites/crckingston.org.au/files/ChildSafe%20-%20Medical%20Consent%20Documents%20-%20U18.pdf">
						ChildSafe Medical Consent Document
					</a>
					<br />
					<br />
					If you have any questions about the camp, or are having difficulty with payment, please contact{" "}
					<a href="mailto:morph@kingstoncrc.org.au">morph@kingstoncrc.org.au.</a>
					<br />
					<br />
					God bless,
					<br />
					Morph Leaders <br />
					<br />
					<input
						type="button"
						onClick={this.resetRegistrationForm}
						value="Register Somebody Else?"
						className="btn btn-primary"
					/>
				</div>
			);
		} else {
			formSubmitted = "";
		}

		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Morph Camp {year}</h1>
					</div>
				</header>
				<section className="container">
					{formSubmitted}
					{registrationForm}
				</section>
			</section>
		);
	}
}

export default MorphCamp;
